import { DataContext } from "../Providers/DataProvider";
import { useContext } from "react";

const useFormData = () => {
  return useContext(DataContext);
};

export { useFormData };
